import SliderFactory from './SliderFactory';

const sliders = document.querySelectorAll('.dealersite-slider');
if (sliders.length > 0) {
  for (const el of sliders) {
    SliderFactory.initialize(el, JSON.parse(el.dataset.options));
  }
}
